// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__HCWEM"};